<button id="big-main-button" type="button" (click)="toggle()" class="toggleButton clickable" [ngClass]="{'active': isPrivacyModusActive, 'only-border-accent': !isPrivacyModusActive}">
	<i-feather class="chatIcon mr-2" [name]="isPrivacyModusActive ? 'lock' : 'unlock'"></i-feather>
	<span class="d-none d-md-inline">{{ 'btn.privacy_protection' | translate}}</span>
</button>
